module.exports = __webpack_public_path__ + "assets/img/cup-text.0921a285.png";